<input id="{{className}}" type="checkbox" name="{{className}}" class="{{className}} boder-black" 
[checked]="verifyCheck()" [ngClass]="{'invalid': required && submitted && !selected }">
<span class="mb-1">{{label}}</span>